import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

const NotaDebitoVentaAltaRedirect: React.FC = () => {
  const [searchParams] = useSearchParams();
  const query = searchParams.toString();
  const target = query ? `/ventas/notas-debito/nuevo-pos?${query}` : '/ventas/notas-debito/nuevo-pos';

  return <Navigate replace to={target} />;
};

export default NotaDebitoVentaAltaRedirect;
